import React from 'react';
import { TouchableOpacity, View, Text, StyleSheet } from 'react-native';
import { MainColors, Status } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const ChoiceCard = (props) => {
    return (
        <TouchableOpacity disabled={props.disabled} onPress={props.onPress}
            style={[styles.container, props.isSelected ? styles.selectedChoice : styles.unselectedChoice]}
        >
            {props.choiceExplanation ? (
                <View style={{ flexDirection: 'row', flexGrow: 1 }}>
                    <View style={styles.choiceTitleContainer}>
                        <Text style={styles.choiceTitle}>{props.choiceTitle}</Text>
                    </View>
                    <View style={[styles.choiceExplanationContainer,
                    props.isSelected ? { borderLeftColor: MainColors.secondary }
                        : { borderLeftColor: MainColors.lightGray }]}>
                        <Text style={styles.choiceExplanation}>{props.choiceExplanation}</Text>
                        {props.createMode ? (
                            <TouchableOpacity
                                style={styles.deleteItemButton}
                                disabled={props.choiceDeleteButtonDisabled}
                                onPress={props.onDeleteChoicePressed}>
                                <MaterialCommunityIcons
                                    name="close-circle-outline"
                                    size={20}
                                    color={props.choiceDeleteButtonDisabled ? MainColors.lightGray : Status.cancelled} />
                            </TouchableOpacity>
                        ) : (null)}
                    </View>
                </View>
            ) : (
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', padding: 5, marginLeft: 5, }}>
                        <Text style={styles.choiceTitle}>{props.choiceTitle}</Text>
                        {props.createMode ? (
                            <TouchableOpacity
                                style={styles.deleteItemButton}
                                disabled={props.choiceDeleteButtonDisabled}
                                onPress={props.onDeleteChoicePressed}>
                                <MaterialCommunityIcons
                                    name="close-circle-outline"
                                    size={20}
                                    color={props.choiceDeleteButtonDisabled ? MainColors.lightGray : Status.cancelled} />
                            </TouchableOpacity>
                        ) : (null)}
                    </View>
                )}
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        padding: 10,
        width: '100%',
        borderWidth: 2
    },
    selectedChoice: {
        borderColor: MainColors.secondary,
        backgroundColor: '#E1F4E1',
    },
    unselectedChoice: {
        borderColor: MainColors.lightGray,
    },
    choiceTitleContainer: {
        width: '40%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 5,
    },
    choiceTitle: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        fontWeight: '600',
        textAlign: 'center',
        lineHeight: 24,
        flexWrap: 'wrap',
        letterSpacing: 0.8
    },
    choiceExplanationContainer: {
        flexDirection: 'row',
        width: '60%',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingVertical: 5,
        paddingLeft: 10,
        borderLeftWidth: 1.2,
    },
    choiceExplanation: {
        fontSize: FontSizes.medium,
        color: MainColors.darkGray,
        flexWrap: 'wrap',
        lineHeight: 20,
        width: '85%',
    },
    deleteItemButton: {
        marginLeft: 5,
        alignSelf: 'center'
    },
});

export default ChoiceCard;